<template>
  <div>
    <div class="title">
      {{ _.abstract }} ID: {{ manager.abstract_id }}
      <span @click="closeModal()"><font-awesome-icon :icon="['fas', 'times']" /></span>
    </div>
    <div class="content" style="overflow: hidden">
      <iframe :src="'https://' + congress + '.abstractserver.com/manager/#/abstract_nowrap/' + manager.abstract_id + '/authors?token=' + key" frameborder="0" style="width: 100%; height: 100%;"></iframe>
    </div>
  </div>
</template>

<script>
import { CONGRESS } from '@/config'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      congress: CONGRESS,
    }
  },
  computed: {
    ...mapGetters(['key', 'manager']),
  },
  methods: {
    ...mapMutations(['closeModal']),
    handleKeyUp(event) {
      if (event.keyCode === 27) {
        this.coseModal();
      }
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.modal {
  > div {
    > div {
      display: grid;
      grid-template-rows: 40px 1fr;
      grid-template-columns: 1fr;
      height: 100%;
      > .title {
        grid-area: 1/1/2/2;
        background: $primary-color;
        color: #ffffff;
        padding: 12px;
        font-weight: bold;
        > span {
          float: right;
          margin-right: 4px;
          opacity: .4;
          &:hover {
            opacity: 1;
          }
        }
        .svg-inline--fa {
          cursor: pointer;
        }
      }
      > .content {
        grid-area: 2/1/3/2;
        background: #ffffff;
        overflow-y: scroll;
        position: relative;
        > div {
          position: relative;
          > div {
            position: relative;
          }
        }
      }
    }
  }
}

</style>